module.exports = __webpack_public_path__ + "static/img/about11.f553917c.png";